import Vue from 'vue'
import VueRouter from 'vue-router'
// New Imports
import { canNavigate } from '@/libs/acl/routeProtection'

// eslint-disable-next-line import/no-cycle
import store from '../store'
import auth from './auth'
import admin from './account'
import hire from './hire-purchase'
import savings from './susu-savings'
import dashboard from './dashboard'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/HomeLayout.vue'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/Home.vue'),
          meta: {
            layout: 'full',
            resource: 'sikanii',
            action: 'access-sikanii-app',
            redirectIfGuest: true,
          },
        },
      ],
    },
    ...auth,
    ...admin,
    ...dashboard,
    ...hire,
    ...savings,
    {
      path: '/expenses',
      name: 'expenses',
      component: () => import('@/views/susu-savings/expenses/Index.vue'),
      meta: {
        redirectIfGuest: true,
        resource: 'general',
        action: 'access-expenses',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        resource: 'sikanii',
        action: 'access-sikanii-app',
      },
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: () => import('@/views/error/UnAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'sikanii',
        action: 'access-sikanii-app',
      },
    },
    {
      path: '/not-verified',
      name: 'unverified',
      component: () => import('@/views/error/Unverified.vue'),
      meta: {
        layout: 'full',
        resource: 'sikanii',
        action: 'access-sikanii-app',
        redirectIfVerified: true,
      },
    },
    {
      path: '*',
      redirect: 'error-404',
      meta: {
        resource: 'sikanii',
        action: 'access-sikanii-app',
      },
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach(async (to, from, next) => {
  await store.restored
  const isLoggedIn = !!store.getters['auth/accessToken']
  const verified = !!store.getters['auth/verified']

  if ((isLoggedIn && !verified) && to.name !== 'unverified') {
    return next({ name: 'unverified' })
  }
  // user tries to visit verified page, take them back home, only verify route has redirectIfVerified
  if (verified && to.meta.redirectIfVerified) {
    return next('/')
  }
  if (!canNavigate(to)) {
    // If not logged in => login
    if (!isLoggedIn) return next({ name: 'login' })
    // If logged in => not authorized
    // remove last route
    localStorage.setItem('unauthorized_module', to.meta.resource)
    return next({ name: 'unauthorized' })
  }
  // Redirect if not logged in
  if (to.meta.redirectIfGuest && !isLoggedIn) {
    return next({ name: 'login' })
  }
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next('/')
  }
  if (to.name === 'active-accounts' && !store.getters['auth/multipleAccounts']) {
    return next({ name: 'login' })
  }
  if (to.meta.resource) {
    // general for expenses
    localStorage.setItem(to.meta.resource === 'general' ? store.getters['auth/currentModule'] : to.meta.resource, to.name)
  }
  return next()
})
export default router
